import { render, staticRenderFns } from "./DishesOrder.vue?vue&type=template&id=2e65ce0f&scoped=true&"
import script from "./DishesOrder.vue?vue&type=script&lang=js&"
export * from "./DishesOrder.vue?vue&type=script&lang=js&"
import style0 from "./DishesOrder.vue?vue&type=style&index=0&id=2e65ce0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e65ce0f",
  null
  
)

export default component.exports